var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(" Cloud Dashboard Sayfası "+_vm._s(_vm.getEnvironmetMessage())+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }